import multilang, { languages } from './multilang'

export default
{
    languages,
    multilang
};
